module.exports = "/images/icon_social_youtube.png?24a176f57fbcef37d30a95eef7409024";